import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyEmail } from './pages/VerifyEmail';
import { Home } from './pages/Home';
import { VideosPage } from './pages/Videos';
import { SalonPage } from './pages/Salon';
import { AdminDashboard } from './pages/AdminDashboard';
import { AIAdmin } from './pages/AIAdmin';
import { Layout } from './components/Layout';
import { DMPage } from './pages/DM';
import { Settings } from './pages/Settings';
import { Mailbox } from './pages/Mailbox';
import { ContactPage } from './pages/Contact';
import { UserProfile } from './pages/UserProfile';
import { TokuRanking } from './pages/Toku';
import { AuditLogs } from './pages/AuditLogs';
import { UStore } from './pages/UStore';

import Neighbors from './pages/Neighbors';

function App() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />

            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="neighbors" element={<Neighbors />} />
                <Route path="videos" element={<VideosPage />} />
                <Route path="salon" element={<SalonPage />} />
                <Route path="admin" element={<AdminDashboard />} />
                <Route path="admin/logs" element={<AuditLogs />} />
                <Route path="ai-admin" element={<AIAdmin />} />
                <Route path="mailbox" element={<Mailbox />} />
                <Route path="audience" element={<DMPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="toku" element={<TokuRanking />} />
                <Route path="u-store" element={<UStore />} />
                <Route path="settings" element={<Settings />} />
                <Route path="users/:userId" element={<UserProfile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default App;
